export default {
  code: '404',
  title: 'Stranka sa nenasla',
  description: 'Stranka, ktoru hladate, neexistuje alebo uz nie je dostupna.',
};
